import { c as _c } from "react/compiler-runtime";
import { IcoStore16 } from '@onefootprint/icons';
import { LinkButton } from '@onefootprint/ui';
import { format } from 'date-fns';
import { useTranslation } from 'react-i18next';
import type { EntityOwnedBusinessInfo } from '@/entity/hooks/use-entity-owned-businesses';
type OwnedBusinessesProps = {
  businesses?: EntityOwnedBusinessInfo[];
};
const formatDate = (date: string) => {
  return format(new Date(date), 'MMM d, yyyy');
};
const OwnedBusinesses = t0 => {
  const $ = _c(23);
  const {
    businesses
  } = t0;
  let t1;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = {
      keyPrefix: "pages.user.vault.businesses"
    };
    $[0] = t1;
  } else {
    t1 = $[0];
  }
  const {
    t
  } = useTranslation("common", t1);
  if (!businesses?.length) {
    return null;
  }
  let t2;
  let t3;
  let t4;
  let t5;
  let t6;
  if ($[1] !== businesses || $[2] !== t) {
    const sortedBusinesses = [...businesses].sort(_temp);
    t4 = "flex flex-col justify-between w-full h-full border border-solid rounded border-tertiary";
    t5 = "Businesses";
    let t7;
    if ($[8] === Symbol.for("react.memo_cache_sentinel")) {
      t7 = <IcoStore16 />;
      $[8] = t7;
    } else {
      t7 = $[8];
    }
    let t8;
    if ($[9] !== t) {
      t8 = t(_temp2);
      $[9] = t;
      $[10] = t8;
    } else {
      t8 = $[10];
    }
    if ($[11] !== t8) {
      t6 = <div className="flex items-center gap-2 px-4 py-2 border-b border-solid border-tertiary bg-secondary">{t7}<p className="text-label-2">{t8}</p></div>;
      $[11] = t8;
      $[12] = t6;
    } else {
      t6 = $[12];
    }
    t2 = "flex flex-col h-full gap-6 p-4";
    let t9;
    if ($[13] !== t) {
      t9 = business => <div key={business.id} className="flex justify-between"><div className="flex flex-col gap-1"><p className="text-label-2 text-primary" id={business.id}>{business.name}</p><div className="flex items-center gap-1"><p className="text-body-2 text-tertiary">{t(_temp3)}</p><p className="text-label-2 text-secondary">{formatDate(business.startTimestamp)}</p></div></div><LinkButton variant="label-2" href={`/businesses/${business.id}`}>{t(_temp4)}</LinkButton></div>;
      $[13] = t;
      $[14] = t9;
    } else {
      t9 = $[14];
    }
    t3 = sortedBusinesses.map(t9);
    $[1] = businesses;
    $[2] = t;
    $[3] = t2;
    $[4] = t3;
    $[5] = t4;
    $[6] = t5;
    $[7] = t6;
  } else {
    t2 = $[3];
    t3 = $[4];
    t4 = $[5];
    t5 = $[6];
    t6 = $[7];
  }
  let t7;
  if ($[15] !== t2 || $[16] !== t3) {
    t7 = <div className={t2}>{t3}</div>;
    $[15] = t2;
    $[16] = t3;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t4 || $[19] !== t5 || $[20] !== t6 || $[21] !== t7) {
    t8 = <div className={t4} aria-label={t5}>{t6}{t7}</div>;
    $[18] = t4;
    $[19] = t5;
    $[20] = t6;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
};
export default OwnedBusinesses;
function _temp(a, b) {
  return new Date(b.startTimestamp).getTime() - new Date(a.startTimestamp).getTime();
}
function _temp2($) {
  return $.title;
}
function _temp3($_0) {
  return $_0.lastActivityAt;
}
function _temp4($_1) {
  return $_1.link;
}